import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController } from 'ionic-angular';

import { UserData } from '../../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../../providers/common-data';
import { ParkbewilligungenData, PbActions } from '../parkbewilligungen-data';
import { AlertController } from 'ionic-angular';
import moment from 'moment';
import { ParkbewilligungenEditPage } from '../parkbewilligungen-edit';
import { PbactionsPage } from '../pbactions/pbactions';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'antraege-list',
  templateUrl: 'antraege-list.html'
})

export class AntraegeListPage implements OnInit {
  actionSheet: ActionSheet;
  eavailability;
  dBegin:any;
  dEnd:any;
  maxDate;
  minDate;
  command: string;
  rowData:any;
  columnDefs:any;
  viewmode:string;
  gridOptions:any;

  selectedpbgname: string;
  selectedpbg: any;
  selectedpbstatus;
  actionactive : boolean;
  @ViewChild('pbGrid') agGrid: AgGridAngular;

  constructor( public common: CommonData
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , public http: Http
              , public config: Config
              , public userData: UserData
              , public pbData: ParkbewilligungenData
              , public alertCtrl: AlertController
              , public toastCtrl: ToastController
              , public popoverCtrl: PopoverController
              )
              {
                this.columnDefs = [
                  {
                    headerName: 'Physische Parkkarte', field: 'pbiddisplay' , filter: "agNumberColumnFilter", width:170
                  },
                  {
                    headerName: 'pbid', field: 'pbid' , filter: "agNumberColumnFilter" , hide:true, suppressToolPanel: true
                  },
                  {
                    headerName: 'mandate_mandid', field: 'mandate_mandid' , filter: "agNumberColumnFilter" , hide:true, suppressToolPanel: true
                  }
                  ,{
                    headerName: 'Id', field: 'pbperioden_id' , filter: "agNumberColumnFilter", resizable: true, width:80
                  }
                  ,{headerName: 'Gültig ab', field: 'valid_from',  resizable: true,  filter: "agDateColumnFilter", width:110,
                    browserDatePicker:true,
                    filterParams: {
                      filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
                      comparator: function(filterLocalDateAtMidnight, cellValue) {
                        
                          if (cellValue === null) return -1;
                          let cellDate = moment(cellValue).toDate();
                          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                          }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        }
                    },
                      browserDatePicker: true
                  }
                  }
                  ,{headerName: 'Gültig bis', field: 'valid_to', filter:'agDateColumnFilter', resizable: true,width:110,
                    browserDatePicker:true,
                    filterParams: {
                      filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
                      comparator: function(filterLocalDateAtMidnight, cellValue) {
                        
                          if (cellValue === null) return -1;
                          let cellDate = moment(cellValue).toDate();
                          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                          }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        }
                    },
                      browserDatePicker: true
                  }
                }
                ,{headerName: 'Kategorie', field: 'kategorie_text', resizable: true, width:220,}                  
                  ,{headerName: 'Name', field: 'name'}
                  ,{headerName: 'Vorname', field: 'vorname'}
                  ,{headerName: 'Firma', field: 'organisation'}
                  ,{headerName: 'Bemerkung', field: 'customercomment'}
                ];      
                

                this.gridOptions = {                
                  isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
                  doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
                  //enableFilter: userData.isAllowed('15','s2')
               }                
                this.viewmode = "pb"

  }

  ionViewWillEnter() {
    this.actionactive = false;
    this.loadGrid();
  }  

  loadGrid(){
    //console.log(this.pbData.periodgroups);
    let pbstatusfilters = [];
    for(let i=0; i<this.pbData.periodgroups.length; i++){      
      pbstatusfilters = pbstatusfilters.concat(this.pbData.periodgroups[i].pbstatus);
    }
    //console.log(pbstatusfilters);
    this.pbData.index(true, pbstatusfilters).then(res => { 
      //console.log(this.pbData.data);
      this.rowData = this.pbData.data;
      //this.agGrid.columnApi.autoSizeAllColumns();
    });
    if(this.userData.isAllowed('17','r')){
      if(this.pbData.periodgroups && this.pbData.periodgroups.length>0){
        if(!this.selectedpbgname){
          this.selectedpbgname = this.pbData.periodgroups[0].name;
          this.selectedpbg = this.pbData.periodgroups[0];  
        }        
      }
      
    }

    this.pbData.loadperiodgroups();
  }

  changePgTab(pbg){
    this.selectedpbgname = pbg.name;
    this.selectedpbg = pbg;
    this.gridOptions.api.onFilterChanged();
  }

  isExternalFilterPresent() {
      return true;
  }
  
  doesExternalFilterPass(node) {
    if(this.userData.isAllowed('17','r')){
      //console.log(this.selectedpbg);
      if(this.selectedpbg){

        for(let i=0; i<this.selectedpbg.pbstatus.length; i++){
          let pbstatus = this.pbData.pbstatus.find(x => x.id ===  this.selectedpbg.pbstatus[i]);
          let pbid_condition = true;  
          let mandid_condition = true;        
          if(this.selectedpbg.where && this.selectedpbg.where.pbid){
            pbid_condition = node.data.pbid > this.selectedpbg.where.pbid;
          }
          if(this.selectedpbg.where && this.selectedpbg.where.mandid && this.selectedpbg.where.mandid>0){

            if(node.data.attributes.pbperiodcount <= 1){
              if(!node.data.mandate_mandid){
                if(this.userData.usergroup_id == 1){
                  mandid_condition = true;
                }
                else{
                  mandid_condition = false;
                }
              }
              else{
                mandid_condition = (node.data.mandate_mandid === this.selectedpbg.where.mandid);
              }
  
            }
            else{
              //-- Check Mandat of Period ----------
              if(this.userData.usergroup_id == 1){
                mandid_condition = true;
              }
              else{
                mandid_condition = (node.data.kategorie_mandate_id === this.selectedpbg.where.mandid);
              }

            }
            
          }
          
          //let pbid = this.selectedpbg.where;
          return ((pbstatus.name == node.data.status_text) || (pbstatus.name == node.data.replacementstatus_text)) && pbid_condition && mandid_condition;    
        }
        return false;
      }  
    }
    else{
      if(this.selectedpbstatus){
        let pbstatus = this.pbData.pbstatus.find(x => x.id ===  this.selectedpbstatus);
        return pbstatus.name == node.data.status_text;            
      }
    }
    return true;
  }
  statusFilterChanged(event){
    //console.log(this.selectedpbstatus);
    this.gridOptions.api.onFilterChanged();
  }
  presentActions(event) {
    let popover = this.popoverCtrl.create(PbactionsPage, {}, {cssClass: 'pbactions-popover'});
    popover.onDidDismiss(data => {
      switch (this.pbData.selectedAction) {
        case PbActions.PrintInvoice:
            this.printinvoices();
            break;
        case PbActions.Replace:
            this.assignNewPb();
            break;
        case PbActions.NewPeriod:
            console.log("create new period");
            break;

        default:
            break;
        }      
    }); 
    popover.present({
      ev: event
    });
  }

  gridClearFilter(){
    this.selectedpbstatus = null;
    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }  
  gridCopyClipboard(){
    this.agGrid.api.copySelectedRowsToClipboard(true);    
  }
  gridRowDblClicked(event: any){ 
    if(this.userData.isAllowed('17','u')){
      this.navCtrl.push(ParkbewilligungenEditPage,{ title: 'Parkbewilligung', icon: 'add', viewmode:'createue', pbkunden_id:event.data.pbkunden_id, pbperioden_id:event.data.pbperioden_id });   
  
    }
}

  ngOnInit() {

  }  
  ngAfterViewInit() {

  }  
  
  getSelectedRows() {
    //console.log("hallo");
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    const selectedDataStringPresentation = selectedData.map( node => node.make + ' ' + node.model).join(', ');
    alert(`Selected nodes: ${selectedDataStringPresentation}`);
}


  async assignNewPb(){

    let rowsSelection = this.agGrid.api.getSelectedRows();

    if(rowsSelection.length <= 0){
      let toast = this.toastCtrl.create({
        message: "Es ist keine Parkkarte ausgewählt",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      
      toast.present();   

    }    

    else if(rowsSelection.length > 1){
      let toast = this.toastCtrl.create({
        message: "Bitte nur eine Parkkarte auswählen",
        position: 'top',
        cssClass: 'toast-error',
        duration: 4000
      });
      
      toast.present();   

    }
    else{
      //console.log(rowsSelection);
      let alert = this.alertCtrl.create({
        title: 'Parkkarte ersetzen',
        message: 'Wollen Sie die Parkkarte '+rowsSelection[0].pbid+' ersetzen? Die Parkkarte wird dadurch ungültig!',
        buttons: [
          {
            text: 'Nein',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Ja',
            handler: () => {
              this.assignNewPb_handler() ;
            }
          }
        ]
      });
      alert.present();    
    }
    

  }

  async assignNewPb_handler(){
      let rowsSelection = this.agGrid.api.getSelectedRows();
      await this.pbData.assignNewPb(rowsSelection[0].pbid);
      if(this.pbData.newpbid && this.pbData.newpbid>0){

        let alert = this.alertCtrl.create({
          title: 'Parkkarte ersetzt',
          message: 'Parkbewilligung '+rowsSelection[0].pbid+' ist durch '+this.pbData.newpbid+' ersetzt worden!',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                
              }
            }
          ]
        });
        alert.present();                    

      }
      console.log('TODO Einsatzplan stornieren');
    
  }
  
  async printinvoices(){
    this.actionactive = true;
    const selectedNodes = this.agGrid.api.getSelectedNodes();    
    const selectedData = selectedNodes.map( node => node.data );
    if(selectedData.length <= 0){
      this.common.showError("Keine Einträge ausgewählt, bitte Einträge in Liste auswählen", 5000);
      return;
    }

    let perioden_ids = "";
    for(let i=0; i<selectedData.length; i++){
      perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
      if( (i+1) != selectedData.length){
        perioden_ids = perioden_ids + ",";
      }      
    }
    //console.log(perioden_ids);
    await this.pbData.printinvoices(perioden_ids);
    this.actionactive = false;
    this.loadGrid();

  }

  async pbssent(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    let perioden_ids = "";
    for(let i=0; i<selectedData.length; i++){
      perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
      if( (i+1) != selectedData.length){
        perioden_ids = perioden_ids + ",";
      }      
    }
    //console.log(perioden_ids);
    await this.pbData.pbssent(perioden_ids);
    this.loadGrid();

  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/antraege/antraege-list.ts